import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [sidebarMinimized, setSidebarMinimized] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [pageTitle, setPageTitle] = useState('');
    const location = useLocation();
    
    // Check screen size on mount and window resize
    useEffect(() => {
        const checkScreenSize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
        
        if (mobile) {
            setSidebarOpen(false);
        } else {
            setSidebarOpen(true);
        }
        };
        
        // Initial check
        checkScreenSize();
        
        // Add event listener
        window.addEventListener('resize', checkScreenSize);
        
        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    useEffect(() => {
        const titleMap = {
            '/': 'Home',
            '/about': 'About Us',
            '/contact': 'Contact',
            '/dashboard': 'Dashboard',
            '/inventory': 'Inventory',
            '/itemgroups': 'Item Groups',
            '/profile': 'My Profile'
        };
        setPageTitle(titleMap[location.pathname] || '');
    }, [location]);
    
    const toggleSidebar = () => {
        // On desktop, toggle between minimized and full sidebar
        if (!isMobile) {
        setSidebarMinimized(!sidebarMinimized);
        } else {
        // On mobile, toggle sidebar visibility
        setSidebarOpen(!sidebarOpen);
        }
    };
    
    return (
        <div className='min-h-[100vh] bg-gray-700'>
            <Sidebar 
                isOpen={sidebarOpen} 
                isMinimized={sidebarMinimized} 
                isMobile={isMobile}
                toggleSidebar={toggleSidebar}
            />
            <div className='pr-2 py-2' style={{ maxHeight: '100vh', transition: 'margin-left 0.3s', marginLeft: !isMobile && sidebarOpen ? (sidebarMinimized ? '52px' : '240px') : '0', }} >
                {isMobile && (
                <Header isMobile={isMobile} isOpen={sidebarMinimized} toggleSidebar={toggleSidebar} pagetitle={pageTitle} />
                )}
                <Container fluid className="h-[calc(100vh-1rem)] bg-gray-100 rounded-md overflow-auto px-3 px-md-4 py-3">
                    {children}
                </Container>
            </div>
        </div>
    );
};

export default Layout;